import { render, staticRenderFns } from "./SystemNotificationButton.vue?vue&type=template&id=73058af8&"
import script from "./SystemNotificationButton.vue?vue&type=script&lang=js&"
export * from "./SystemNotificationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports